import { render, staticRenderFns } from "./LogoLong.vue?vue&type=template&id=ba2e2004&scoped=true&"
import script from "./LogoLong.vue?vue&type=script&lang=js&"
export * from "./LogoLong.vue?vue&type=script&lang=js&"
import style0 from "./LogoLong.vue?vue&type=style&index=0&id=ba2e2004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2e2004",
  null
  
)

export default component.exports